var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.acf_field.type == 'image')?_c('AcfImg',{attrs:{"value":_vm.acf_field.value}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.acf_field.value)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }